export interface FAQItem {
    id: string
    question: string
    answer: string
    category: 'General' | 'Admission' | 'Pédagogie' | 'Vie Étudiante' | 'Financement'
    favorite?: boolean
}

export const useFAQ = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const getAllFAQ = async (): Promise<FAQItem[]> => {
        try {
            const { data, error } = await useFetch(`${apiBase}/oxoweb/faq`)
            if (error.value) {
                console.error('Error fetching FAQ:', error.value)
                return []
            }
            return (data.value as FAQItem[]) || []
        } catch (e) {
            console.error('Error fetching FAQ:', e)
            return []
        }
    }

    const getFAQByCategory = async (category: string): Promise<FAQItem[]> => {
        const all = await getAllFAQ()
        if (category === 'Tous') return all
        return all.filter(item => item.category === category)
    }

    const getFavoriteFAQ = async (): Promise<FAQItem[]> => {
        try {
            const { data, error } = await useFetch(`${apiBase}/oxoweb/faq/favorites`)
            if (error.value) {
                console.error('Error fetching favorite FAQ:', error.value)
                return []
            }
            return (data.value as FAQItem[]) || []
        } catch (e) {
            console.error('Error fetching favorite FAQ:', e)
            return []
        }
    }

    const getCategories = () => {
        return ['Tous', 'General', 'Admission', 'Pédagogie', 'Vie Étudiante', 'Financement']
    }

    return {
        getAllFAQ,
        getFAQByCategory,
        getFavoriteFAQ,
        getCategories
    }
}
